import React, { useState, useEffect, useContext } from 'react';
import { Grid } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import axiosInstance from '../../api';
import { authContext } from '../../routes';
import SERVER_API_URL from '../../config';
import MiniWidgetSummary from './MiniWidgetSummary';

export default function MiniAppWidgetSummary() {
    const { user } = useContext(authContext);

    const [loggedUsers, setLoggedUsers] = useState();
    const [loggedUsersWithCredential, setLoggedUsersWithCredentials] = useState();

    const dioceseLevel = user && user.role.permissions.dioceseLevel.read;
    const districtLevel = user && user.role.permissions.districtLevel.read;
    const churchLevel = user && user.role.permissions.churchLevel.read;

    useEffect(() => {
        const getLoggedUsers = async () => {
            try {
                let response;
                if (dioceseLevel) {
                    response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/loggedUsers`);
                } else if (districtLevel) {
                    response = await axiosInstance.post(
                        `${SERVER_API_URL}/dashboard/findLoggedUsersByDistrictId/${user && user.church.district.id}`
                    );
                } else {
                    response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/findLoggedUsersByChurchId/${user && user.church.id}`);
                }
                if (response.status === 200) {
                    setLoggedUsers(response.data.length);
                }
            } catch (error) {
                // console.log(error);
            }
        };

        const getLoggedUsersWithCredentials = async () => {
            try {
                let response;
                if (dioceseLevel) {
                    response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/findNotLoggedUsersWithCredential`);
                } else if (districtLevel) {
                    response = await axiosInstance.post(
                        `${SERVER_API_URL}/dashboard/findNotLoggedUsersWithCredentialByDistrictId/${user && user.church.district.id}`
                    );
                } else {
                    response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/findNotLoggedUsersWithCredentialByChurchId/${user && user.church.id}`);
                }
                if (response.status === 200) {
                    setLoggedUsersWithCredentials(response.data.length);
                }
            } catch (error) {
                // console.log(error);
            }
        };

        getLoggedUsers();
        getLoggedUsersWithCredentials();
    }, [dioceseLevel, districtLevel, user]);

    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.up('xs'));
    const lg = useMediaQuery(theme.breakpoints.up('lg'));
    const xl = useMediaQuery(theme.breakpoints.up('xl'));

    return (
        <Grid container spacing={3}>
            {churchLevel && (
                <>
                    <Grid item xs={12} sm={6} lg={12}>
                        <MiniWidgetSummary
                            title={(xl||xs && !lg ) ? "ስርዓቱን እየተጠቀሙ ያሉ" : "የገቡ"}
                            subheader={(xl||xs && !lg)  ? "ወደ ስርዓቱ ቢያንስ አንዴ የገቡ" : "ቢያንስ አንዴ የገቡ"}
                            total={loggedUsers}
                            color="secondary"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={ 12}>
                        <MiniWidgetSummary
                            title={(xl||xs && !lg)  ? "ስርዓቱን መጠቀም ያልጀመሩ" : "ያልገቡ"}
                            subheader={(xl||xs && !lg)  ? "የተጠቃሚ ስም እያላቸው ያልገቡ" : "እየቻሉ"}
                            total={loggedUsersWithCredential}
                            color="primary"
                        />
                    </Grid>
                </>
            )}
        </Grid>
    )
}
